import { EndPoints } from '../../common/enums/enums';
import { api } from './api';

export const notificationsServices = api.injectEndpoints({
  endpoints: build => ({
    getNotifications: build.query({
      query: ({ page, personId }) =>
        EndPoints.USER.GET_NOTIFICATIONS.ENDPOINT.replace(
          '{personId}',
          personId
        ).replace('{pageNumber}', page),
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        return `${endpointName}(${queryArgs.personId})`;
      },
      forceRefetch({ currentArg, previousArg }) {
        return (
          currentArg.personId !== previousArg?.personId ||
          currentArg.page > previousArg?.page
        );
      },
      merge: (currentData, responseData) => {
        currentData.extraValues = responseData.extraValues;
        currentData.pagination = responseData.pagination;
        currentData.notifications.push(...responseData.notifications);
      },
    }),
    markNotificationAsRead: build.mutation({
      query: ({ notificationId }) => ({
        url: EndPoints.USER.MARK_NOTIFICATION_AS_READ.ENDPOINT.replace(
          '{notificationId}',
          notificationId
        ),
        method: 'PATCH',
        body: { readOn: true },
      }),
      async onQueryStarted(
        { personId, notificationId },
        { dispatch, queryFulfilled }
      ) {
        const patchResult = dispatch(
          api.util.updateQueryData(
            'getNotifications',
            { personId },
            previousData => {
              const edited = previousData.notifications.find(
                notification => notification.notificationId === notificationId
              );

              edited.readOn = true;
              previousData.extraValues.totalUnreadNotifications--;
            }
          )
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    markAllNotificationsAsRead: build.mutation({
      query: ({ personId }) => ({
        url: EndPoints.USER.MARK_ALL_NOTIFICATIONS_AS_READ.ENDPOINT.replace(
          '{personId}',
          personId
        ),
        method: 'PATCH',
        body: {},
      }),
      async onQueryStarted({ personId }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          api.util.updateQueryData(
            'getNotifications',
            { personId },
            previousData => {
              previousData.notifications = previousData.notifications.map(
                notification => ({
                  ...notification,
                  readOn: Date.now(),
                })
              );

              previousData.extraValues.totalUnreadNotifications = 0;
            }
          )
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation,
} = notificationsServices;
